/**
 * Clinical → Assignments (`/solutions/clinical/assignments`, ADR-0043).
 *
 * The eTMF completeness rows assigned to the signed-in user: read the full
 * check result, open the Vault document, mark it reviewed. Every role.
 */

import { useState } from "react";
import { Container, Paper, Stack, Text, ThemeIcon, Title } from "@mantine/core";
import { IconUserCheck } from "@tabler/icons-react";
import { EtmfReviews } from "./EtmfReviews";

export function AssignmentsPage() {
  const [count, setCount] = useState<number | null>(null);
  return (
    <Container size="xl" py="md">
      <Stack gap="md">
        <div>
          <Title order={2}>Assignments</Title>
          <Text c="dimmed" size="sm">
            eTMF artifacts assigned to you for review. Read the check results, open the document,
            and mark it reviewed.
          </Text>
        </div>
        <EtmfReviews onCount={setCount} />
        {count === 0 && (
          <Paper withBorder radius="md" p="xl">
            <Stack align="center" gap="xs">
              <ThemeIcon variant="light" size={48} radius="xl">
                <IconUserCheck size={26} />
              </ThemeIcon>
              <Text fw={600}>Nothing assigned to you</Text>
              <Text c="dimmed" size="sm">
                When someone assigns you an artifact in an eTMF completeness trial, it appears here.
              </Text>
            </Stack>
          </Paper>
        )}
      </Stack>
    </Container>
  );
}
